import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import './SearchDropdown.css';

function SearchDropdown({ results, isLoading, isVisible, query, onClose }) {
  const navigate = useNavigate();

  if (!isVisible) return null;

  const handleUserClick = (username) => {
    onClose();
    navigate(`/profile/${username}`);
  };

  const getBadge = (user) => {
    if (user.isPro) {
      return 'pro';
    }
    const role = (user.role || user.userType || '').toLowerCase();
    if (role === 'streamer' || role === 'admin') {
      return role;
    }
    return '';
  };

  const getAvatarUrl = (user) => (
    user.profileImage
    || user.profile_picture_url
    || user.profilePictureUrl
    || user.oauthProfileImage
    || null
  );

  return (
    <div className="search-dropdown">
      {isLoading && (
        <div className="search-dropdown__loading">Searching...</div>
      )}

      {!isLoading && query && results.length === 0 && (
        <div className="search-dropdown__empty">No users found</div>
      )}

      {!isLoading && results.length > 0 && (
        <ul className="search-dropdown__list">
          {results.map((user) => (
            <li key={user.id || user.username}>
              <button
                type="button"
                className="search-dropdown__item"
                onClick={() => handleUserClick(user.username)}
              >
                <div className="search-dropdown__avatar">
                  {getAvatarUrl(user) ? (
                    <img src={getAvatarUrl(user)} alt="" referrerPolicy="no-referrer" />
                  ) : (
                    <span className="search-dropdown__avatar-placeholder">
                      {(user.username || '?').charAt(0).toUpperCase()}
                    </span>
                  )}
                </div>
                <div className="search-dropdown__info">
                  <span className="search-dropdown__username">{user.username}</span>
                </div>
                {getBadge(user) && (
                  <span className={`search-dropdown__badge search-dropdown__badge--${getBadge(user)}`}>
                    {getBadge(user)}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

SearchDropdown.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string,
    profileImage: PropTypes.string,
    profilePictureUrl: PropTypes.string,
    profile_picture_url: PropTypes.string,
    oauthProfileImage: PropTypes.string,
    isPro: PropTypes.bool,
    role: PropTypes.string,
    userType: PropTypes.string,
  })).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  query: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SearchDropdown;
